import { makeObservable, observable, action, runInAction } from 'mobx';

import type { FileResponseItem } from '../models.ts';
import apiService from './apiService.ts';

class FolderStore {
  @observable folders: FileResponseItem[] | null = null;
  private _loading = false;

  constructor() {
    makeObservable(this);
  }

  async ensureLoaded() {
    if (this.folders !== null || this._loading) return;
    this._loading = true;
    try {
      const folders = await apiService.get<FileResponseItem[]>('/api/file/folders');
      runInAction(() => { this.folders = folders; });
    } catch {
      // not authenticated or network error — will retry on next call
    } finally {
      this._loading = false;
    }
  }

  @action
  setFolders(folders: FileResponseItem[]) {
    this.folders = folders;
  }

  async reload() {
    this._loading = false;
    runInAction(() => { this.folders = null; });
    await this.ensureLoaded();
  }
}

export const folderStore = new FolderStore();
